// -----------------------------------------------------------------------------
// Scripts for gallery sliders
// -----------------------------------------------------------------------------

$(function () {
  const galleries = $('.section-gallery');

  $.each(galleries, function(index, value) {
    const singleSlider = $(this).find('.gallery-single').attr('id');
    const navSlider = $(this).find('.gallery-nav').attr('id');

    $(`#${singleSlider}`).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      fade: true,
      prevArrow: '<div class="section-gallery__arrow slick-prev"><i class="fa fa-arrow-circle-left"></i></div>',
      nextArrow: '<div class="section-gallery__arrow slick-next"><i class="fa fa-arrow-circle-right"></i></div>',
      asNavFor: `#${navSlider}`
    });
  
    $(`#${navSlider}`).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        focusOnSelect: true,
        prevArrow: '<div class="section-gallery__arrow slick-prev"><i class="fa fa-arrow-circle-left"></i></div>',
        nextArrow: '<div class="section-gallery__arrow slick-next"><i class="fa fa-arrow-circle-right"></i></div>',
        asNavFor: `#${singleSlider}`,
      });
  });

  

  lightbox.option({
    'fitImagesInViewport': true,
    'disableScrolling': true,
    'fadeDuration': 300
  });
});